import { Stack, Typography } from '@mui/material';

export default function StatDescription({ icon, description, width, height, maxWidth }) {
	return (
		<Stack spacing={2} direction="row" alignItems="center">
			{icon && (
				<img src={icon} alt={description} width={width} height={height} />
			)}
			<Typography
				sx={{
					maxWidth: maxWidth || '106px',
					color: '#464646',
					fontFamily: 'Roboto',
					fontStyle: 'normal',
					fontWeight: '400',
					fontSize: '16px',
					lineHeight: '24px',
					letterSpacing: '0.15px',
				}}
			>
				{description}
			</Typography>
		</Stack>
	);
}
